import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useDispatch } from 'react-redux';

import {
    Text,
    NoInformation,
    PatientHistoryCard,
    GoBackButton,
    ProviderInfoCard,
    SessionSummaryCard,
    StyledCard,
    StyledCardContent,
    Header,
    HomeworkProgress,
} from '../index';

import { mindgymReport } from '../../services';

import { alertError } from '../../redux/stateActions';

import { MONTHS } from '../../constant';

import { processMindgymReport } from '../../utils/mindgym';

export const MedicalRecordCard = ({ mdUp, mobileS, onGoBack, data, user }) => {
    const dispatch = useDispatch();

    const [selectedRecord, setSelectedRecord] = useState(null);

    const handleDetail = (record) => {
        setSelectedRecord(record);

        if (user?.uuid && record?.meet?.type === 'one') {
            const staffId = record?.meet?.staff?.id;
            const sessionId = record?.id;
            handleGetMindGymReport(staffId, sessionId);
        }
    };

    const handleDate = (time) => {
        const date = new Date(time);
        // return date.toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });

        return `Record ${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
    };

    const handleGoback = () => {
        setSelectedRecord(null);
        setMindgymActivity([]);
    };

    /*--------------- Mindgym Activity ---------------*/
    const [mindgymActivity, setMindgymActivity] = useState([]);

    const handleGetMindGymReport = async (staffId, sessionId) => {
        try {
            if (!staffId || !sessionId) return;

            const res = await mindgymReport(staffId, sessionId);

            if (res?.data?.statusCode === 200) {
                setMindgymActivity(processMindgymReport(res?.data?.data));
            }
        } catch (error) {
            console.log('error', error.response);
            dispatch(
                alertError(`Cannot get Friday Activity: ${error.response?.data?.message}`)
            );
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
            {selectedRecord ? (
                <Fragment>
                    {mdUp ? (
                        <GoBackButton $text onClick={handleGoback} />
                    ) : (
                        <Header
                            onClickGoBack={handleGoback}
                            showGoBack1
                            childrenContainerStyle={{ textAlign: 'center' }}
                        >
                            <Text $fontSize="16px">{handleDate(selectedRecord.date)}</Text>
                        </Header>
                    )}
                    <ProviderInfoCard data={selectedRecord?.meet?.staff} mobileS={mobileS} />
                    <SessionSummaryCard title="Session Summary" data={selectedRecord} consultTime />
                    <StyledCard>
                        <StyledCardContent>
                            <Text $bold $fontSize="18px">
                                My note
                            </Text>
                            <Text>{selectedRecord?.patient_summaries[0]?.myNote}</Text>
                        </StyledCardContent>
                    </StyledCard>
                    {!_.isEmpty(mindgymActivity) && <HomeworkProgress data={mindgymActivity} />}
                </Fragment>
            ) : (
                <Fragment>
                    {!mdUp && (
                        <Header
                            onClickGoBack={onGoBack}
                            showGoBack1
                            childrenContainerStyle={{ textAlign: 'center' }}
                        >
                            <Text $fontSize="16px">Medical Record</Text>
                        </Header>
                    )}
                    <Text $bold $fontSize="18px">
                        Medical Record
                    </Text>
                    {data && data.length > 0 ? (
                        data
                            .map((record, hIndex) => (
                                <PatientHistoryCard
                                    key={`record${hIndex}`}
                                    data={record}
                                    onDetail={() => handleDetail(record)}
                                />
                            ))
                            .reverse()
                    ) : (
                        <NoInformation />
                    )}
                </Fragment>
            )}
        </div>
    );
};

MedicalRecordCard.propTypes = {
    mdUp: PropTypes.bool,
    mobileS: PropTypes.bool,
    onGoBack: PropTypes.func,
    data: PropTypes.arrayOf(PropTypes.object),
};
